/* eslint-disable jsx-a11y/iframe-has-title */

import { Component } from "react";
import axios from "axios";

import ClientBackHeader from "../../components/ClientBackHeader";
import { BACKEND_CONFIG } from "../../config/consts";

class EditApplicationContainer extends Component {
  messsagelistener;
  constructor(props) {
    super(props);

    this.state = {
      redirectToUrl: null,
    };

    this.messsagelistener = (e) => {
      if (e.data === "uaQuoteReady") {
        this.props.history.push(`/client/${this.props.match.params.clientId}`);
      }
    };

    window.addEventListener("message", this.messsagelistener, false);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.messsagelistener, false);
  }

  componentDidMount() {
    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}edit-application/${this.props.match.params.clientId}`
      )
      .then((response) => {
        this.setState({ redirectToUrl: response.data.redirectToUrl });
      });
  }

  render() {
    let redirectToUrl = this.state.redirectToUrl;

    return (
      <>
        <div className="service-request-submit mb-5">
          <ClientBackHeader
            clientId={this.props.match.params.clientId}
            goBack={() =>
              this.props.history.push(
                `/client/${this.props.match.params.clientId}`
              )
            }
          />
          <iframe
            src={redirectToUrl}
            className="edit-application-frame"
            onLoad={(e) => {
              let win = e.target.contentWindow || e.target;
              if (win.postMessage) {
                win.postMessage("iClose", "*");
              }
            }}
          />
        </div>
      </>
    );
  }
}

export default EditApplicationContainer;
